<template>
  <div>
    <div class="auto-wallet-container" v-if="!mobile">
      <div v-if="wallet">
        <p>{{ `${$t('wallet.connected')}&nbsp;${briefAddr}` }}</p>
        <el-button plain @click="submit()" :loading="submitLoading">{{ $t('send') }}</el-button>
        <span v-if="['TON', 'USDT_TON', 'NOT', 'SOL', 'USDC_SOL'].includes(payType)"
              @click="disconnect()"
              class="btn-disconnect"></span>
      </div>
      <div v-else class="auto-wallet-container">
        <el-button plain @click="generateWallet(payType)">{{ $t('wallet.connect') }}</el-button>
      </div>
    </div>

    <div v-else class="tabs-container">
      <p>
        {{ $t('wallet.mobile') }}
      </p>
      <div class="mobile-wallet">
        <span @click="openWallet('OKX')">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA1UlEQVR4AWJwL/CBY0D7ZYCBQQhE4at0iU6RAB2pe0TnCKDsUTpFfw/YVoPo32dpeNDsvPmWStPDdqWu9ifB2ww9b80vsXC/LvSEGM0HCITBAkkWAIkIkADQuBISzrkWY2whhEHee8kIuef38IDXOgAKZ1FrFc2QmwS8lgFAvwsAXh8EOADY0TB8KufclFJNaz0Ia8hNauC1DiAJjYRATqrbB4C/FQK5DwMcAMIm3H8MSyn7juG5CQ8A/UFCe5IRxH+WWyKA4Y9m/OF0HM/NC+O5vff8ARHpaPq63KdGAAAAAElFTkSuQmCC"
                 class="type-icon"/>
            OKX
        </span>
        <span @click="openWallet('META')">
            <img src="data:image/png;base64,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"
                 class="type-icon"/>
            MetaMask
        </span>
        <span @click="openWallet('TP')">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAMFBMVEVHcEwKgf82iP4pgP4pgP4pgP4pgP4sgv8ogP8pgP4pgP4ogP4ogP4pgP4qgf5Ej/+BjsvoAAAAD3RSTlMAAWP/wo73qQ97KEYe6diwe2k2AAAAiElEQVR4AWMYMMAoKCgogMRnMgYBBwbRZOMKsAAnWMCSKxlIbkAImAqDSCuEgE0xiLQFCfCEzjU2nnoAyAVqOgA2hc/YmIHb2PgCi7GxArJAAVDzBGSBT9vA1iAE/hsDaTQBU3SBBwKoAuYMKCqely4QQBEoADJxCLAA/SAFdhQCgDQLMgwgAADwMCmLSXpfsgAAAABJRU5ErkJggg=="
                 class="type-icon"/>
            TP
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { TonConnect } from '@/utils/tonconnect';
import { mapState, mapMutations } from 'vuex';
import BN from 'bn.js';
import Web3 from 'web3';
import { ABI } from '@/utils'
import { postImpl } from '@/utils/solanaPost';
import { PublicKey } from '@solana/web3.js';
import { Transaction } from '@solana/web3.js';

export default {
  data() {
    return {
      mobile: null,
      wallet: null,
      web3Module: null,
      tonModule: new TonConnect(this.$tonConnect),
      submitLoading: false
    }
  },
  props: [
    'payAmount',
    'payAddress'
  ],
  computed: {
    briefAddr() {
      let wallet = this.wallet
      // return wallet
      return wallet && `${wallet.substr(0, 6)}***${wallet.substr(wallet.length - 4, 4)}` || ''
    },
    ...mapState({
      payType: (state) => state.payType,
      order_id: (state) => state.orderData.order.order_id,
      memo: (state) => state.orderData.order.salt,
    })
  },
  methods: {
    ...mapMutations([
      'showStatus',
    ]),
    async disconnect() {
      if (['TON', 'USDT_TON', 'NOT'].includes(this.payType)) {
        this.wallet = null;

        this.tonModule.disconnect();
      } else if (['SOL', 'USDC_SOL', 'PYUSD_SOL'].includes(this.payType)) {

        if (window.solana) {
          await window.solana.disconnect();
          this.wallet = null;
        }
      }
    },
    openWallet(wallet) {
      const dappUrl = window.location.href
      let deepLink

      if (wallet === 'OKX') {
        const encodedDappUrl = encodeURIComponent(dappUrl);
        deepLink = 'okx://wallet/dapp/url?dappUrl=' + encodedDappUrl;
      } else if (wallet === 'TP') {
        const urlObj = {
          'url': dappUrl,
          'chain': 'ETH',
          'source': 'xxx'
        }
        deepLink = 'tpdapp://open?params=' + encodeURIComponent(JSON.stringify(urlObj))
      } else if (wallet === 'META') {
        deepLink = 'https://metamask.app.link/dapp/' + dappUrl;
      } else if (wallet === 'TP') {
        const urlObj = {
          'url': dappUrl,
        }
        const encodedDappUrl = encodeURIComponent(urlObj);
        deepLink = 'tpdapp://open?params=' + encodedDappUrl;
      }
      location.href = deepLink
      return deepLink
    },
    isMobileDetection() {
      const ua = navigator.userAgent;
      const isIOS = /iphone|ipad|ipod|ios/i.test(ua);
      const isAndroid = /android|XiaoMi|MiuiBrowser/i.test(ua);
      return isIOS || isAndroid;
    },
    checkAutoWallet(Web3) {
      let that = this

      const isMobile = that.isMobileDetection();
      if (isMobile) {
        that.mobile = isMobile;
      }
      if (window.ethereum) {
        window.ethereum.enable().then(function () {
          let web3;
          if (window.ethereum) {
            web3 = new Web3(window.ethereum);
          }

          if (web3) {
            that.web3 = web3;

            window.ethereum.request({ method: 'eth_requestAccounts' }).then((myAccounts) => {
              const SenderAddress = myAccounts && myAccounts.length > 0 ? myAccounts[0] : undefined;
              if (SenderAddress) {
                that.wallet = SenderAddress
              }
            });
          }
        });
      } else {
        let web3;
        if (window.web3) {
          web3 = new Web3(window.web3.currentProvider);
          if (web3) {
            that.web3 = web3;

            window.ethereum.request({ method: 'eth_requestAccounts' }).then((myAccounts) => {
              const SenderAddress = myAccounts && myAccounts.length > 0 ? myAccounts[0] : undefined;
              if (SenderAddress) {
                that.wallet = SenderAddress
              }
            });
          }
        }
      }

    },
    async switchNetwork(targetNetworkId) {
      try {
        const currentNetworkId = await this.web3.eth.net.getId();
        console.log('Network ID', currentNetworkId, targetNetworkId);
        if (parseInt(currentNetworkId) !== parseInt(targetNetworkId)) {
          await this.web3.currentProvider.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: targetNetworkId }],
          });
        }
      } catch (error) {
        throw new Error(error.message)
      }
    },
    async submit() {
      const wallet = this.wallet;
      const payCurrency = this.payType
      const address = this.payAddress // todo
      const value = this.payAmount.toString() // todo
      const { toWei } = this.web3Module && this.web3Module.utils || {};

      if (['SOL', 'USDC_SOL', 'PYUSD_SOL'].includes(payCurrency)) {
        // Solana Network
        try {
          this.submitLoading = true;

          const wl = await this.getSolanaAddress()
          const res = await postImpl(wl, payCurrency, value, this.payAddress, String(this.memo))
          // const transaction = Transaction.from(Buffer.from(responseBody.transaction, 'base64'));

          // const res = await window.solana.signAndSendTransaction(transaction)

          this.showStatus(true)

          this.submitLoading = false;
          console.log('🚀 ~ submit ~ res:', res)

        } catch (error) {
          this.submitLoading = false;
          console.log(error)
          // element ui message
          this.$message({
            message: 'You have canceled the payments',
            type: 'error'
          })

        }
      } else if (['USDT_TON', 'TON', 'NOT'].includes(payCurrency)) {
        // TON Network
        try {
          this.submitLoading = true;
          const payload = {
            senderAddress: this.tonModule.address,
            receiverAddress: this.payAddress,
            amount: this.payAmount,
            memo: String(this.memo),
          };

          if (payCurrency === 'USDT_TON') {
            await this.tonModule.sendJettonTransaction(payload, 'usdt');
          } else if (payCurrency === 'NOT') {
            await this.tonModule.sendJettonTransaction(payload, 'not')
          } else {
            await this.tonModule.sendTransaction(payload);
          }

          this.submitLoading = false;
          this.showStatus(true)
        } catch (error) {
          this.submitLoading = false;
          console.log(error)
          this.$message({
            message: 'You have canceled the payments',
            type: 'error'
          })
        }
      } else if (this.wallet && this.web3 && this.web3.eth) {
        // EVM Network
        if (['P2P_USDT_ERC20', 'USDT_ARB', 'USDT_CELO', 'USDT_BNB', 'USDC', 'USDC_ARB', 'USDV_ARB', 'EURT', 'XAUT', 'CUSD_CELO', 'USDC_BASE', 'USDC_POL', 'USDCE_POL'].includes(payCurrency)) {
          let USDxAddress;
          let targetNetworkId = '0x1';
          if (payCurrency === 'P2P_USDT_ERC20') {
            USDxAddress = '0xdac17f958d2ee523a2206206994597c13d831ec7';
            targetNetworkId = '0x1';
          } else if (payCurrency === 'USDT_ARB') {
            USDxAddress = '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9';
            targetNetworkId = '0xa4b1';
          } else if (payCurrency === 'USDT_CELO') {
            USDxAddress = '0x48065fbbe25f71c9282ddf5e1cd6d6a887483d5e';
            targetNetworkId = '0xa4ec';
          } else if (payCurrency === 'USDT_BNB') {
            USDxAddress = '0x55d398326f99059fF775485246999027B3197955';
            targetNetworkId = '0x38';
          } else if (payCurrency === 'USDC') {
            USDxAddress = '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48';
            targetNetworkId = '0x1';
          } else if (payCurrency === 'USDC_ARB') {
            USDxAddress = '0xaf88d065e77c8cc2239327c5edb3a432268e5831';
            targetNetworkId = '0xa4b1';
          } else if (payCurrency === 'USDV_ARB') {
            // switch network
            USDxAddress = '0x323665443CEf804A3b5206103304BD4872EA4253';
            targetNetworkId = '0xa4b1';
          } else if (payCurrency === 'EURT') {
            USDxAddress = '0xC581b735A1688071A1746c968e0798D642EDE491';
            targetNetworkId = '0x1';
          } else if (payCurrency === 'XAUT') {
            USDxAddress = '0x68749665ff8d2d112fa859aa293f07a622782f38';
            targetNetworkId = '0x1';
          } else if (payCurrency === 'CUSD_CELO') {
            USDxAddress = '0x765DE816845861e75A25fCA122bb6898B8B1282a';
            targetNetworkId = '0xa4ec';
          } else if (payCurrency === 'USDC_BASE') {
            USDxAddress = '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913';
            targetNetworkId = '0x2105';
          } else if (payCurrency === 'USDC_POL') {
            USDxAddress = '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359';
            targetNetworkId = '0x89';
          } else if (payCurrency === 'USDCE_POL') {
            USDxAddress = '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174';
            targetNetworkId = '0x89';
          }

          try {
            this.submitLoading = true;

            console.log('Submitting payCurrency ', payCurrency, targetNetworkId)
            await this.switchNetwork(targetNetworkId);

            const USDxContract = new this.web3.eth.Contract(ABI, USDxAddress);
            const amountFloat = parseFloat(value) * 100;
            const decimals = new BN(4);
            const amount = new BN(Math.floor(amountFloat));
            const tokenAmountStr = amount.mul(new BN(10).pow(decimals)).toString('hex');
            let tokenAmountHex = `0x${tokenAmountStr}`;

            // Custom Amount HEX for USDT BNB and CUSD CELO
            if (['USDT_BNB', 'CUSD_CELO'].includes(payCurrency)) {
              tokenAmountHex = toWei(value, 'ether');
            }

            const res = await USDxContract.methods.transfer(address, tokenAmountHex).send({ from: wallet });

            console.log('🚀 ~ submit ~ res:', res)
            this.showStatus(true);
            this.submitLoading = false;
          } catch (error) {
            console.log(error)
            this.submitLoading = false;
            this.$message({
              message: error.message,
              type: 'error'
            })
          }
        } else if (['P2P_ETH', 'ETH_ARB', 'ETH_BASE'].includes(payCurrency)) {
          const web3Eth = new Web3(window.ethereum);

          // Convert amount to send from Ether to Wei
          const amountToSend = web3Eth.utils.toWei(this.payAmount.toString(), 'ether'); // Amount in Wei

          let defaultNetwork = '0x1';
          if (payCurrency === 'ETH_ARB') {
            defaultNetwork = '0xa4b1'
          } else if (payCurrency === 'ETH_BASE') {
            defaultNetwork = '0x2105'
          }

          try {
            this.submitLoading = true;
            await this.switchNetwork(defaultNetwork);

            // Get the nonce (transaction count)
            const nonce = await web3Eth.eth.getTransactionCount(wallet, 'latest');

            const tx = {
              from: wallet,
              to: address,
              value: amountToSend,
              chainId: parseInt(defaultNetwork, 16),
              nonce
            }

            const isEip = ['ETH_ARB', 'ETH_BASE'].includes(payCurrency)
            let gasPriceOrFeeData;
            if (isEip) {
              const block = await web3Eth.eth.getBlock('pending');
              const baseFee = parseInt(block.baseFeePerGas);
              const margin = 50000
              tx.maxPriorityFeePerGas = BigInt(baseFee - margin);
              tx.maxFeePerGas = BigInt(baseFee + margin);
            } else {
              // For legacy networks
              gasPriceOrFeeData = await web3Eth.eth.getGasPrice();
              tx.gasPrice = web3Eth.utils.toHex(gasPriceOrFeeData);
            }

            // Estimate the gas required for the transaction
            const estimatedGas = await web3Eth.eth.estimateGas(tx);

            // Set the gas limit with a small buffer
            tx.gas = estimatedGas;

            const res = await web3Eth.eth.sendTransaction(tx);

            console.log('🚀 ~ submit ~ res:', res)
            this.showStatus(true);
            this.submitLoading = false;
          } catch (error) {
            this.submitLoading = false;
            const isInsufficient = error?.message.includes('insufficient funds')
            this.$message({
              message: isInsufficient ? 'Insufficient funds for the payments' : error?.data?.message || 'You have canceled the payments',
              type: 'error'
            })
          }
        }
      }
    },
    async getSolanaAddress() {
      try {
        if (window.solana) {
          let wallet;
          if (window.solana.isConnected) {
            wallet = window.solana;
          } else {
            const res = await window.solana.connect({
              // version:1
            });
            if (res.publicKey) {
              wallet = window.solana;
            } else {
              console.log('User denied wallet connection');
            }
          }
          this.wallet = new PublicKey(wallet.publicKey).toBase58();
          return this.wallet;
        } else {
          this.$message({
            message: 'Please install the wallet extension.',
            type: 'error'
          })

          this.wallet = null;
          console.log('Phantom wallet not detected. Please install the Phantom extension.');
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getTonAddress() {
      try {
        const address = await this.tonModule.connect();
        if (address) {
          this.wallet = address.toString();
        }
      } catch (error) {
        this.$message({
          message: error || 'Please install the wallet extension.',
          type: 'error'
        })

        this.wallet = null;
      }
    },
    async generateWallet(payType) {
      if (['SOL', 'USDC_SOL', 'PYUSD_SOL'].includes(payType)) {
        // Reset wallet when using solana network
        this.wallet = null;

        this.wallet = await this.getSolanaAddress();
      } else if (['TON', 'USDT_TON', 'NOT'].includes(payType)) {
        this.wallet = null;
        await this.getTonAddress()
      } else {
        // Default
        import('web3').then(Web3 => {
          this.web3Module = Web3.default
          this.checkAutoWallet(this.web3Module)
        })
      }
    }
  },
  watch: {
    payType(val, oldVal) {
      this.generateWallet(val)
    }
  },
  async created() {
    this.generateWallet(this.payType);
  },
}
</script>

<style lang="scss" scoped>
.auto-wallet-container {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  margin-top: 10px;

  p {
    margin-top: 0;
    text-align: center;
  }

  button {
    width: 100%;
    padding: 0px;
    height: 32px;
    line-height: 32px;
    color: #4e5c6e;

    &:hover, &:focus, &:active {
      border: 1px solid #55b5ff !important;
      color: #55b5ff;
    }
  }
}

.tabs-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .mobile-wallet {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;

    .type-icon {
      width: 18px;
      margin: 0 4px;
      border-radius: 50%;
      border: 1px solid rgba(0, 0, 0, 0.1);
    }

    span {
      padding: 6px 12px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 2px;
      cursor: pointer;
      font-size: 14px;
      height: 32px;
      display: flex;
      align-items: center;

      &.active {
        color: #55b5ff;
        border-color: #55b5ff;
      }
    }
  }

}

.btn-disconnect {
  color: #f56c6c;
  transition: all 0.2s ease-in-out 0s;
  cursor: pointer;
  display: flex;
  margin: 14px auto 0;
  justify-content: center;
}

.btn-disconnect:hover {
  text-decoration: underline;
}

</style>
